import React from 'react';
import ModalButtons from "../ModalButtons/ModalButtons";
import GroupContractBuilderTabContent from "./GroupContractBuilderTabContent";
import Tabs from  '../Tabs/Tabs';
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import DateHelper from "../DateHelper/DateHelper";
import ObjectHelper from "../ObjectHelper/ObjectHelper";
import GroupContractBuilderErrors from './GroupContractBuilderErrors';

class GroupContractBuilder extends React.Component {

	constructor(props) {
		super(props)

		var self = this

    if (this.props.buttons) {
      this.buttons = this.props.buttons
    } else {
      if (this.props.read_only) {
        this.buttons = [
          {
            name: I18n.t('ok'),
            html_attributes: [
              'data-dismiss="modal"'
            ]
          }
        ]
      } else {
        this.buttons = [
          {
            name: I18n.t('cancel'),
            html_attributes: [
              'data-dismiss="modal"'
            ]
          },
          {
            name: I18n.t('submit'),
            button_classes: ['primary'],
            onClick: function (e) {
              e.stopPropagation()
              e.preventDefault()
              self.onSave()
            }
          }
        ]
      }

    }

		this.state = {
      active_tab: this.props.active_tab || 'general',
      loading: false,
      read_only: this.props.read_only,
      new_record: this.props.new_record,

      date_format: this.props.date_format,
      time_format: this.props.time_format,

      errors: this.props.errors || [],

      id: this.props.id,
      code: this.props.code || '',
      name: this.props.name || '',
      description: this.props.description || '',
      status: this.props.status,
      maximum_stay: this.props.maximum_stay,
      minimum_stay: this.props.minimum_stay,
      check_in_time: this.props.check_in_time ? DateHelper.parseTime(this.props.check_in_time) : '',
      check_out_time: this.props.check_out_time ? DateHelper.parseTime(this.props.check_out_time) : '',
      end_date: this.props.end_date ? DateHelper.parse(this.props.end_date) : null,
      start_date: this.props.start_date ? DateHelper.parse(this.props.start_date) : null,
      updated_at: this.props.updated_at,

      group_contract_prices: this.props.group_contract_prices || [],
      group_contract_rates: this.props.group_contract_rates || [],

      group_contract_notes_path: this.props.group_contract_notes_path,
      note_count: this.props.note_count || null,
			note_obj: this.props.note || {
				note: null,
				notable_type: null,
				notable_id: null,
				flagged: false,
				user: null,
				created_at: null,
				updated_at: null
			},
      image_group: this.props.image_group,

      all_room_types: this.props.all_room_types || [],
      all_rates: this.props.all_rates || []
		}

		this.onChange = this.onChange.bind(this)
		this.onChangeNote = this.onChangeNote.bind(this)
		this.onChangeImageGroup = this.onChangeImageGroup.bind(this)
		this.updateNoteCount = this.updateNoteCount.bind(this)
    this.onChangeFlagged = this.onChangeFlagged.bind(this)
    this.onChangeRates = this.onChangeRates.bind(this)
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this)
		this.onSave = this.onSave.bind(this)
	}

  componentDidUpdate(prevProps, prevState) {
    if (typeof initTypeahead == 'function' && this.refs.root) {
      window.initTypeahead($(this.refs.root).find("[data-model][data-column]"))
    }
  }

	render() {
		return (
			<div className="group-contract-builder" ref="root">
        <Tabs tabs={this.tabs()} displayErrorMessage={(GroupContractBuilderErrors.general(this.state.errors).length || GroupContractBuilderErrors.pricing(this.state.errors).length || GroupContractBuilderErrors.rates(this.state.errors).length || GroupContractBuilderErrors.notes(this.state.errors).length) ? true : false} />
				<div className="panel panel-form">
          { this.props.nested ? null : <ModalButtons loading={this.state.loading} buttons={this.buttons} /> }
          {
            this.props.reservation
            ? <div className="alert alert-warning">
                <h4 style={{marginTop: 5, textAlign: 'center'}}><strong><span className="ss-lock"></span> {I18n.t('record_locked')}</strong></h4>
                <hr />
                <p className="text-center">{I18n.t('master_reservation_created_group_contract_cannot_be_edited')}</p>
              </div>
            : null
          }
          <GroupContractBuilderTabContent
            {...this.state}
            onChange={this.onChange}
            onChangeNote={this.onChangeNote}
            onChangeImageGroup={this.onChangeImageGroup}
            onChangeFlagged={this.onChangeFlagged}
            onChangeRates={this.onChangeRates}
            updateNoteCount={this.updateNoteCount}
            buttons={this.buttons} />
  			  <LoadingSpinner show={this.state.loading} />
        </div>
			</div>
		)
	}

  tabs() {
    return (
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.active_tab === 'general' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: GroupContractBuilderErrors.general(this.state.errors).length
        },
        {
          tabName: I18n.t('pricing'),
          targetName: 'pricing',
          classes: this.state.active_tab === 'pricing' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: GroupContractBuilderErrors.pricing(this.state.errors).length
        },
        {
          tabName: I18n.t('rates'),
          targetName: 'rates',
          classes: this.state.active_tab === 'rates' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: GroupContractBuilderErrors.rates(this.state.errors).length
        },
        {
          tabName: I18n.t('notes'),
          targetName: 'notes',
          classes: this.state.active_tab === 'notes' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: GroupContractBuilderErrors.notes(this.state.errors).length
        },
      ]
    );

  };

  renderFieldErrors(field) {
    if (this.state.errors && this.state.errors[field]) {
      var idx = 0
      var errors = this.state.errors[field].map( (error) => {
        idx = idx + 1
        return <li key={idx}><b>&#x2022;</b> {error}</li>
      })
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  renderFieldClasses(field) {
    var classname = 'form-control'
    if (this.state.errors && Object.keys(this.state.errors).length && this.state.errors[field]) {
      classname = classname + ' has-errors'
    }
    return classname
  }

  onChange(event) {
    if (event && event.target) {
      this.state[event.target.name] = event.target.value;
      this.forceUpdate()
    }
  }

  onChangeActiveTab(active_tab) {
    this.setState({active_tab: active_tab})
  }

	onChangeImageGroup(image_group) {
		this.setState({image_group: image_group})
	}

	onChangeNote(noteText) {
		if (noteText) {
			var note_obj = Object.assign({}, this.state.note_obj)
			note_obj.note = noteText

			this.setState({
				note_obj: note_obj
			})
		}
	}

	updateNoteCount(count) {
    this.setState({note_count: count})
  }

	onChangeFlagged(event) {
		var note_obj = this.state.note_obj
		note_obj['flagged'] = event.target.checked
		this.setState({note_obj: note_obj})
	}

  onChangeRates(selected_rates) {
    this.setState({group_contract_rates: selected_rates})
  }

	onSave() {
    this.setState({loading: true})
    var params = this.prepParams()

    $.ajax({
      type: this.props.new_record ? 'POST' : 'PUT',
      url: this.props.form_action,
      data: params
    }).done((data) => {
      window.parent.$(window.parent).trigger('groupContractSaved', data)
      this.setState({loading: false})
      if (parent && parent.refresh_data) {
        if (this.props.new_record == true) {
          parent.refresh_data(I18n.t('group_contract_created_successfully'));
        } else {
          parent.refresh_data(I18n.t('group_contract_saved_successfully'));
        }
      }
      if (parent && parent.hide_modal) {
        parent.hide_modal()
      }
    }).catch((data) => {
      if (data && data.responseJSON) {
        this.setState({errors: data.responseJSON, loading: false})
        $('.modal-body').scrollTop(0)
      }
    })
	}

  prepParams() {
		if (this.state.note_obj.note) {
			var note_obj = this.state.note_obj
		}

    var params = {
      group_contract: {
        code: this.state.code,
        name: this.state.name,
        start_date: this.state.start_date,
        end_date: this.state.end_date,
        maximum_stay: this.state.maximum_stay,
        minimum_stay: this.state.minimum_stay,
        check_in_time: this.state.check_in_time,
        check_out_time: this.state.check_out_time,
        description: this.state.description,
        status: this.state.status,
        updated_at: this.state.updated_at,
      },
			note: note_obj || null,
			image_group_images: this.state.image_group && this.state.image_group.images ? this.state.image_group.images.map(function (image) { return image.id; }) : null,
      group_contract_rates: this.state.group_contract_rates
    }

    var group_contract_prices = []
    for (var i = 0, ilen = this.state.group_contract_prices.length; i < ilen; i++) {
      var group_contract_price = ObjectHelper.clone(this.state.group_contract_prices[i])
      delete group_contract_price['group_contract']
      group_contract_price['group_contract_id'] = this.state.id,
      group_contract_prices.push(group_contract_price)
    }
    params['group_contract_prices'] = group_contract_prices

    return params
  }

}

export default GroupContractBuilder
